import {
  PlanStack,
  PlanType,
  PlanV2,
} from '@zapier/design-system-revenue/src/types';

/**
 * Returns the yearly billed plan with the lowest yearly billed amount for the specified plan type.
 * @param planStacks
 * @param planType
 */
export const getLowestPlan = (
  planStacks: Array<PlanStack>,
  planType: PlanType
): PlanV2 | undefined => {
  if (planStacks.length === 0) {
    return undefined;
  }

  const planStack = planStacks.find(stack => stack.planType === planType);

  if (!planStack) {
    return undefined;
  }

  const plans = planStack.plans;

  if (!plans || plans.length === 0) {
    return undefined;
  }

  /**
   * Sometimes free plans only have one interval, and it's not always consistent as
   * to which interval, so let's take care of free plans in advance before we get to the
   * filter on interval next.
   */
  if (planType === 'Free') {
    return plans[0];
  }

  const lowestAmount = Math.min(
    ...plans.filter(plan => plan.interval === 'year').map(plan => plan.amount)
  );

  return plans.find(plan => plan.amount === lowestAmount);
};
